import { Input } from '../../../Components'
import { cap } from '../../../State'
import { translations } from '../../../translations'
const language = cap.language.state || 'IT'
const t = translations[language]

const listOfFormalita = [
  { label: t.pocoFormale, value: 30 },
  { label: t.formaleDefault, value: 75 },
  { label: t.moltoFormale, value: 100 }
]

const listOfEmails = [
  { label: 'lgiraudo@siapcn.it', value: 'lgiraudo@siapcn.it' },
  { label: 'mranocchia@siapcn.it', value: 'mranocchia@siapcn.it' },
  { label: 'murru@siapcn.it', value: 'murru@siapcn.it' },
  { label: 'atomatis@siapcn.it', value: 'atomatis@siapcn.it' },
  { label: 'mbolla@siapcn.it', value: 'mbolla@siapcn.it' }
]

function SettingsParameterTest({
  selectedFormalita,
  setSelectedFormalita,
  debugMode,
  units,
  selectedUnit,
  setSelectedUnit,
  travellersOptions,
  selectedPID,
  setSelectedPID,
  selectedEmail,
  setSelectedEmail,
  selectedEnvironment,
  setSelectedEnvironment,
  environmentList
}) {
  return (
    <div className="nrow nora-test-params">
      <div className="nfield" style={{ gridColumn: 'span 3' }}>
        <label>{t.indicateFormalityLevel}</label>
        <Input
          id="levelFormalita"
          dropdown
          options={listOfFormalita}
          value={selectedFormalita}
          placeholder={t.selectFormalityLevel}
          style={{ fontSize: 13, width: '100%', borderRadius: 8 }}
          onChange={({ levelFormalita }) => setSelectedFormalita(levelFormalita)}
        />
      </div>
      {!!debugMode && (
        <div className="nfield" style={{ gridColumn: 'span 3' }}>
          <label>{t.selectPID}</label>
          <Input
            id="unit"
            dropdown
            options={travellersOptions}
            value={selectedPID}
            placeholder={t.selectPID}
            style={{ fontSize: 13, width: '100%', borderRadius: 8 }}
            onChange={({ unit }) => setSelectedPID(unit)}
          />
        </div>
      )}
      <div className="nfield" style={{ gridColumn: 'span 3' }}>
        <label>{t.selectEmailRedirect}</label>
        <Input
          id="unit"
          dropdown
          options={listOfEmails}
          value={selectedEmail}
          placeholder={t.selectEmail}
          style={{ fontSize: 13, width: '100%', borderRadius: 8 }}
          onChange={({ unit }) => setSelectedEmail(unit)}
        />
      </div>
      <div className="nfield" style={{ gridColumn: 'span 3' }}>
        <label>{t.selectEnvironment}</label>
        <Input
          id="environment"
          dropdown
          options={environmentList}
          value={selectedEnvironment}
          optionLabel="societyName"
          optionValue="codSociety"
          placeholder={t.selectEnvironmentPlaceholder}
          style={{ fontSize: 13, width: '100%', borderRadius: 8 }}
          onChange={({ environment }) => setSelectedEnvironment(environment)}
        />
      </div>
    </div>
  )
}

export default SettingsParameterTest
